import { useEffect, useState } from 'react';
import { apolloClientFactory, NarvarApolloClient } from '@narvar/apollo-client';
import { onError } from 'apollo-link-error';
import { from as apolloLinkFrom } from 'apollo-link';

const useApolloClient = (): NarvarApolloClient<unknown>['client'] | null => {
  const [apolloClient, setApolloClient] = useState<
    NarvarApolloClient<unknown>['client'] | null
  >(null);

  useEffect(() => {
    const { client, startCacheTtlChecker } = apolloClientFactory({
      fetch,
      uri: process.env.LOMA_URL,
      ssrMode: false,
      addTypename: true,
      maxBatch: 20,
      disablePersistedCache: false,
      link: ({ retry, batch, rest }) => {
        const error = onError(({ graphQLErrors, networkError, operation }) => {
          if (graphQLErrors) {
            graphQLErrors.forEach(({ message, locations, path }) =>
              console.error(
                `[GraphQL error]: OperationName: ${
                  operation.operationName
                } Message: ${message}, Location: ${JSON.stringify(
                  locations,
                )}, Path: ${JSON.stringify(path)}, Variables: ${JSON.stringify(
                  operation.variables,
                )}`,
              ),
            );
          }
          if (networkError) {
            const { response } = networkError as Partial<
              Extract<typeof networkError, { response: Response }>
            >;
            console.error(
              `[GraphQL network error]: OperationName: ${
                operation.operationName
              } Message: ${JSON.stringify(networkError)}${
                response
                  ? `, Headers: ${JSON.stringify([
                      ...response.headers.entries(),
                    ])}`
                  : ''
              }`,
            );
          }
        });
        return apolloLinkFrom([rest, retry, error, batch]);
      },
    });
    setApolloClient(client);
    startCacheTtlChecker();
  }, []);

  return apolloClient;
};

export default useApolloClient;
